export interface GetRemovedChainsParams {
  whitelistChains: string[];
  currentChains: string[];
}

export function getRemovedChains(params: GetRemovedChainsParams): string[] {
  const { currentChains, whitelistChains } = params;

  return whitelistChains.filter(chain => !currentChains.includes(chain));
}
